import { pgTable, text, boolean, timestamp, integer, bigint, index, uniqueIndex, foreignKey, jsonb } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { adminUser } from './admin';
import { chatRoom } from './messaging';
import type { translatableEntityType } from './enums';

export const apiKey = pgTable('ApiKey', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  keyType: text().notNull(),
  name: text().notNull(),
  value: jsonb().notNull(),
  isActive: boolean().default(true).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
});

export const crmSync = pgTable('CRMSync', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  adminUserId: integer().notNull(),
  crmLeadId: integer(),
  crmContactId: integer(),
  lastSyncAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  syncStatus: text().default('SYNCED').notNull(),
  syncError: text(),
}, (table) => [
  uniqueIndex('CRMSync_adminUserId_key').using('btree', table.adminUserId.asc().nullsLast()),
  index('CRMSync_crmLeadId_idx').using('btree', table.crmLeadId.asc().nullsLast()),
  foreignKey({
    columns: [table.adminUserId],
    foreignColumns: [adminUser.id],
    name: 'CRMSync_adminUserId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

export const integrationSettings = pgTable('IntegrationSettings', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  amoCrmTokens: text(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
});

export const supportTicket = pgTable('SupportTicket', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  userId: integer().notNull(),
  question: text().notNull(),
  status: text().default('OPEN').notNull(),
  chatId: bigint({ mode: 'number' }).notNull(),
  messageId: integer(),
  assignedAdminId: integer(),
  chatRoomId: integer(), // Связь с чатом поддержки
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  resolvedAt: timestamp({ precision: 3, mode: 'date' }),
}, (table) => [
  index('SupportTicket_assignedAdminId_idx').using('btree', table.assignedAdminId.asc().nullsLast()),
  index('SupportTicket_status_idx').using('btree', table.status.asc().nullsLast()),
  index('SupportTicket_userId_idx').using('btree', table.userId.asc().nullsLast()),
  index('SupportTicket_chatRoomId_idx').using('btree', table.chatRoomId.asc().nullsLast()),
  foreignKey({
    columns: [table.assignedAdminId],
    foreignColumns: [adminUser.id],
    name: 'SupportTicket_assignedAdminId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
  foreignKey({
    columns: [table.chatRoomId],
    foreignColumns: [chatRoom.id],
    name: 'SupportTicket_chatRoomId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
]);

export const translation = pgTable('Translation', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  entityType: text().$type<typeof translatableEntityType.enumValues[number]>().notNull(),
  entityId: integer().notNull(),
  languageCode: text().notNull(),
  data: jsonb().notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('Translation_entityType_entityId_idx').using('btree', table.entityType.asc().nullsLast(), table.entityId.asc().nullsLast()),
  uniqueIndex('Translation_entityType_entityId_languageCode_key').using('btree', table.entityType.asc().nullsLast(), table.entityId.asc().nullsLast(), table.languageCode.asc().nullsLast()),
  index('Translation_entityType_languageCode_idx').using('btree', table.entityType.asc().nullsLast(), table.languageCode.asc().nullsLast()),
  index('Translation_languageCode_idx').using('btree', table.languageCode.asc().nullsLast()),
]);
